export const ApiShortQuery = Symbol('ApiShortQuery');
